import { memo } from 'react';

interface LeaderboardIconProps {
  width?: number;
  height?: number;
  color?: string;
}

export const LeaderboardIcon = memo(
  ({ width = 24, height = 24, color = 'currentColor' }: LeaderboardIconProps) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 21H17"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17V21"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 3H6.5C5.67157 3 5 3.67157 5 4.5V5C5 8.86599 8.13401 12 12 12C15.866 12 19 8.86599 19 5V4.5C19 3.67157 18.3284 3 17.5 3Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 4H3.5C3.22386 4 3 4.22386 3 4.5V6C3 7.65685 4.34315 9 6 9H6.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 4H20.5C20.7761 4 21 4.22386 21 4.5V6C21 7.65685 19.6569 9 18 9H17.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

LeaderboardIcon.displayName = 'LeaderboardIcon';

